/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  OnInit
} from '@angular/core';
import { EntityFinderDialog, EntityFinderParams, ISortModel, ProxAgFns, RowSelectionMultipleCheckbox } from '@core';

import { Kit } from '@models';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { UtilFns } from '@utils';
import { ColDef } from '@ag-grid-community/core';
import { AccountDbQueryService } from '../services/account-db-query.service';


export interface KitFinderParams extends EntityFinderParams {
  accountId?: string,
  kits?: Kit[];
}

@Component({
    selector: 'prox-kit-finder',
    template: EntityFinderDialog.HTML,
    standalone: false
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class KitFinderDialog extends EntityFinderDialog<Kit, KitFinderParams> {
  params!: KitFinderParams;

  constructor(
    ref: DynamicDialogRef,
    override config: DynamicDialogConfig<KitFinderParams>,
    public dbQueryService: AccountDbQueryService,

  ) {
    super(ref, config);
    UtilFns.assertNonNull(config.data);
    this.params = config.data;
    //UtilFns.assertNonNull(this.params.kits, 'kits');
  }

  override async initialize() {
    return {
      header: `Select Kits`,
      width: 'calc(40vw)',
      rowModelType: 'clientSide',
      rowSelection: RowSelectionMultipleCheckbox
    } as const;
  }

  override async initDatasource() {
    const datasource = (await this.dbQueryService.createKitsByAccountIdQuery(<string>this.params.accountId)).execute();
    return datasource;
    // return this.params.kits ?? [];
  }

  override getColDefsAndSortModel() {
    const colDefs = [
      { headerName: 'Supplier', field: 'supplierAccount.supplier.name',  filter: 'agTextColumnFilter',   },
      { headerName: 'Kit Name', field: 'name', filter: 'agTextColumnFilter', },
      // I like this checkbox here too!  Please retain.
      // The new AG Grid 32+ doesn't support more than a single checkbox column because it is now set on the gridOptions.rowSelection property.
      { headerName: 'Description', field: 'description', filter: 'agTextColumnFilter',  }, 
      ProxAgFns.getActiveStatusColDef('activeStatus.name'),
    ] as ColDef[]
    const sortModel = [
      { colId: 'name', sort: 'asc' }
    ] as ISortModel
    return [ colDefs, sortModel] as const;
  }
}